import { render, staticRenderFns } from "./addsound.vue?vue&type=template&id=2a60ca88&scoped=true&"
import script from "./addsound.vue?vue&type=script&lang=js&"
export * from "./addsound.vue?vue&type=script&lang=js&"
import style0 from "./addsound.vue?vue&type=style&index=0&id=2a60ca88&prod&scoped=true&lang=css&"
import style1 from "./addsound.vue?vue&type=style&index=1&id=2a60ca88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60ca88",
  null
  
)

export default component.exports